/**
 * Нормализует имена глобальных Base-компонентов при регистрации приложения.
 * Не регистрирует компоненты самостоятельно и не зависит от Vue runtime.
 */

/**
 * Возвращает уникальные исходное, kebab-case и PascalCase имена компонента.
 * Алиасы нужны, пока исторические Base-компоненты имеют неодинаковые `name`.
 */
export function getComponentRegistrationNames(name) {
  const kebabName = name
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .toLowerCase();
  const pascalName = kebabName
    .split("-")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join("");

  return [...new Set([name, kebabName, pascalName])];
}
